import {NodeDto} from "./NodeDto";

export class FlowDto {
    keyId: string = '';
    id: string = '';
    code: string = '';
    name: string = '';
    context: string = '';
    currentNodeId: string = '';
    startTime: string = '';
    finishTime: string = '';
    status: string = '';
    nodes: Array<NodeDto> = [];
}